export enum SvgLibraryEvents {
  SET_SVG_PAGINATED_VALUE = '[Set SVG_PAGINATED_VALUE] Action',
  SET_SEARCH_SVG_PAGINATED_VALUE = '[Set SEARCH_SVG_PAGINATED_VALUE] Action',
}
